import styled from 'styled-components'
import Icon from '../../components/Icon'

export const StyledDateline = styled.div`
    height: 26px;
`

export const StyledLine = styled.div`
    position: relative;
    width: calc(100% - 26px);
    height: 100%;
    margin: 0 auto;
    &:before {
        content: '';
        display: block;
        position: absolute;
        top: 50%;
        left: 0;
        height: 2px;
        width: 100%;
        background: ${({ theme }) => theme.veryLightPink};
        margin-top: -1px;
    }
`

export const StyledDateWrapper = styled.div`
    position: absolute;
    top: 50%;
    left: ${({ left }) => left};
    margin-top: -13px;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 38px;
    margin-left: -19px;
`

export const StyledIcon = styled(Icon)`
    margin-bottom: 5px;
`

export const StyledDate = styled.div`
    font-size: 14px;
    letter-spacing: 0.5px;
    font-weight: ${({ theme }) => theme.fontWeight.bold};
    color: ${({ theme }) => theme.brownGrey};
`

export const StyledDateDiff = styled.div`
    position: absolute;
    top: -14px;
    left: ${({ left }) => left};
    font-size: 13px;
    letter-spacing: 0.5px;
    font-weight: ${({ theme }) => theme.fontWeight.bold};
    color: ${({ theme }) => theme.brownGrey};
    width: 28px;
    margin-left: -14px;
    white-space: nowrap;
`